import React from 'react';
import Card from './Card.js'
import {
  bordado,
  brindes,
  canecas,
  cartao_visita,
  coletes,
  cracha,
  flayer,
  folhas,
  lona,
  painel,
  pvc,
  sacolas,
  t_shirts,
  toalhas,
  vinil

} from '../../sharedcomponents/ImageScope'


import './Cards.css'

export default function Cards(){
  return(
    <div className="Cards_main">
       <Card CardService_title={"Bones"} CardService_background={bordado} />
       <Card CardService_title={"Cartão de Visitas"} CardService_background={cartao_visita}/>
       <Card CardService_title={"Brindes"} CardService_background={brindes}/>
       <Card CardService_title={"Flayers"} CardService_background={flayer}/>
       <Card CardService_title={"Painel"} CardService_background={painel}/>
       <Card CardService_title={"T-Shirts"} CardService_background={t_shirts}/>
       <Card CardService_title={"Toalhas"} CardService_background={toalhas}/>
       <Card CardService_title={"Sacolas"} CardService_background={sacolas}/>
       <Card CardService_title={"Vinil"} CardService_background={vinil}/>
       <Card CardService_title={"Coletes"} CardService_background={coletes}/>
       <Card CardService_title={"PVC"} CardService_background={pvc}/>
       <Card CardService_title={"Canencas"} CardService_background={canecas}/>
       <Card CardService_title={"Crachás"} CardService_background={cracha}/>
       <Card CardService_title={"Folhas"} CardService_background={folhas}/>
       <Card CardService_title={"Lona"} CardService_background={lona}/>
    </div>
  );
}